import { render, staticRenderFns } from "./VisitedLessons.vue?vue&type=template&id=bb522000&scoped=true&lang=pug&"
import script from "./VisitedLessons.vue?vue&type=script&lang=js&"
export * from "./VisitedLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb522000",
  null
  
)

export default component.exports